import classnames from 'classnames';
import styles from '../OrganizationSettings.module.css';
import { PBX_ROLE_LINES_TAB, PBX_USER_LINES_TAB, PBXTab, PBXLinesList } from '../../../../types';
import UserRoleAssigneeRow from './UserRoleAssigneeRow';

type UserRoleAssigneeTableProps = {
  category: PBXTab;
  pbxSelfServiceEnabled: boolean;
  getAllPbxLinesInOrg: ({
    category,
    existingLines,
    pageNumber,
  }: {
    category: string;
    existingLines: PBXLinesList[];
    pageNumber: number;
  }) => void;
  onLineDetailsSaved: () => void;
  results?: PBXLinesList[];
  selected: string[];
  setSelected: (selected: string[]) => void;
  organizationId: string;
  toggleSelected: (id: string) => void;
  setPbxLinesList: (pbxLinesList: PBXLinesList[]) => void;
};

export default function UserRoleAssigneeTable({
  category,
  pbxSelfServiceEnabled,
  getAllPbxLinesInOrg,
  onLineDetailsSaved,
  results,
  setPbxLinesList,
  selected,
  setSelected,
  toggleSelected,
  organizationId,
}: UserRoleAssigneeTableProps) {
  // Only User Lines and Roles Lines rows render an Edit action, so the header must
  // drop the Line Details column on the other tabs to stay aligned with its rows.
  const canEditLineDetails =
    pbxSelfServiceEnabled && (category === PBX_USER_LINES_TAB || category === PBX_ROLE_LINES_TAB);

  return (
    <div className={styles.assigneeRows}>
      <div
        className={classnames(styles.tableHeaderRow, {
          [styles.noLineDetailsColumn]: !canEditLineDetails,
        })}
      >
        <div />
        <div className={styles.tableHeaderCell}>Extension / Number</div>
        <div className={styles.tableHeaderCell}>Assignee</div>
        {canEditLineDetails && <div className={styles.tableHeaderCellRight}>Line Details</div>}
      </div>
      {results &&
        results.map((result) => (
          <UserRoleAssigneeRow
            category={category}
            pbxSelfServiceEnabled={pbxSelfServiceEnabled}
            getAllPbxLinesInOrg={getAllPbxLinesInOrg}
            onLineDetailsSaved={onLineDetailsSaved}
            result={result}
            key={result.id}
            targetId={result.targetId}
            selected={selected}
            setSelected={setSelected}
            pbxLinesList={results}
            toggleSelected={toggleSelected}
            setPbxLinesList={setPbxLinesList}
            organizationId={organizationId}
          />
        ))}
    </div>
  );
}
